import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ValidateDialogComponent } from 'src/app/dialogs/validate-dialog/validate-dialog.component';
import { CNConsultation } from 'src/app/models/cnconsultation';
import { CNMedication } from 'src/app/models/cnmedication';
import { CNTreatment } from 'src/app/models/cntreatment';
import { CNTreatmentKine } from 'src/app/models/cntreatmentkine';
import { CNTreatmentLogo } from 'src/app/models/cntreatmentlogo';
import { TreatmentService } from 'src/app/services/treatment.service';

@Component({
  selector: 'app-contact-logo-treatment',
  templateUrl: './contact-logo-treatment.component.html',
  styleUrls: ['./contact-logo-treatment.component.scss']
})
export class ContactLogoTreatmentComponent implements OnInit {

  private theContact: CNConsultation;
  public treatment: CNTreatmentLogo;

  constructor(private dialog: MatDialog, private treatments: TreatmentService) { }

  ngOnInit(): void {
  }

  @Input() set contact(contact: CNConsultation) {
    this.theContact = contact;
    let activeTreatment: CNMedication | CNTreatment;
    if (this.theContact.id === 0) {
      // new contact, search for treatment in patient current treatments
      // tslint:disable-next-line:max-line-length
      activeTreatment = Array.from(this.treatments.treatments.values()).find(treatment => (treatment instanceof CNTreatmentLogo) && treatment.isActive);
    } else {
      activeTreatment = contact.treatments(CNTreatmentLogo).find(treatment => treatment.isActive);
    }
    if (!activeTreatment) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        title: 'Voulez-vous créer un nouveau traitement Logopédie ?',
        ok: {
          label: 'Créer',
          code: 'ok'
        },
        cancel: {
          label: 'Annuler',
          code: 'cancel'
        }
      };
      const dialogRef = this.dialog.open(ValidateDialogComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result => {
        if (result === 'ok') {
          // create new treatment
          this.treatment = new CNTreatmentLogo();
          this.theContact.addTreatment(this.treatment);
        }
      });
    } else {
      this.treatment = activeTreatment as CNTreatmentLogo;
    }
    if (this.treatment) {
      this.theContact.addTreatment(this.treatment);
    }
  }

  get contact(): CNConsultation {
    return this.theContact;
  }

  setSessionCount(count: number): void {
    this.treatment.sessionCount = count;
  }
}
